import { gql, TypedDocumentNode } from "@apollo/client";

export type AgentChatTurn = {
  id: string;
  loggedAt: string;
  durationMs: number;
  userMessage: string | null;
  assistantReply: string | null;
  flags: string[];
  toolInvocations: unknown;
  toolResultsPreview: string | null;
  improvementPrompt: string | null;
  error: string | null;
};

export type AgentChatConversation = {
  id: string;
  lastLoggedAt: string;
  firstLoggedAt: string;
  preview: string | null;
  qualityFlags: string[];
  needsImprovement: boolean;
  turns: AgentChatTurn[];
};

export type AgentChatConversationsResponse = {
  agentChatConversations: {
    nodes: AgentChatConversation[];
  };
};

export type AgentChatConversationsVariables = {
  first?: number;
};

export const AGENT_CHAT_CONVERSATIONS_QUERY: TypedDocumentNode<
  AgentChatConversationsResponse,
  AgentChatConversationsVariables
> = gql`
  query AgentChatConversations($first: Int) {
    agentChatConversations(first: $first) {
      nodes {
        id
        lastLoggedAt
        firstLoggedAt
        preview
        qualityFlags
        needsImprovement
        turns {
          id
          loggedAt
          durationMs
          userMessage
          assistantReply
          flags
          toolInvocations
          toolResultsPreview
          improvementPrompt
          error
        }
      }
    }
  }
`;
